import { COLOR_OPTIONS } from 'config/style';

export interface FlightStageColors {
  backgroundColor: string;
  borderColor: string;
}

export const getFlightStageColors = (flightRealization: string): FlightStageColors => {
  const colorMap: Record<string, FlightStageColors> = {
    OUT_OF_SEASON: {
      backgroundColor: COLOR_OPTIONS.NEUTRAL_10,
      borderColor: COLOR_OPTIONS.NEUTRAL_20
    },
    BEGINNING_OF_THE_FLIGHT: {
      backgroundColor: COLOR_OPTIONS.BLUE_10,
      borderColor: COLOR_OPTIONS.BLUE_70
    },
    FAST_GROWING_POPULATION: {
      backgroundColor: COLOR_OPTIONS.BLUE_10,
      borderColor: COLOR_OPTIONS.BLUE_60
    },
    PEAK_OF_THE_FLIGHT: {
      backgroundColor: COLOR_OPTIONS.BLUE_10,
      borderColor: COLOR_OPTIONS.BLUE_50
    },
    EGG_DEPOSITION_PEAK: {
      backgroundColor: COLOR_OPTIONS.BLUE_10,
      borderColor: COLOR_OPTIONS.BLUE_40
    },
    LARVAL_HATCHING_PEAK: {
      backgroundColor: COLOR_OPTIONS.BLUE_10,
      borderColor: COLOR_OPTIONS.BLUE_30
    },
    END_OF_THE_FLIGHT: {
      backgroundColor: COLOR_OPTIONS.BLUE_10,
      borderColor: COLOR_OPTIONS.BLUE_20
    },
    BETWEEN_GENERATION: {
      backgroundColor: COLOR_OPTIONS.NEUTRAL_10,
      borderColor: COLOR_OPTIONS.NEUTRAL_00
    }
  };

  return (
    colorMap[flightRealization] || {
      backgroundColor: COLOR_OPTIONS.NEUTRAL_10,
      borderColor: COLOR_OPTIONS.NEUTRAL_20
    }
  );
};
